import {
  baseRoute,
  baseRoutePrefixRegex,
  nonProviderRoutes,
  providerPrefixPath,
  providerPrefixRegex,
  queryStringRegex,
  widgetPrefixPath,
  widgetPrefixRegex,
} from './constants'

const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1)

function prefixRoutes(routes) {
  return routes.map((route) => {
    const nonProviderRoutesWithBaseRoute = nonProviderRoutes.map(route => `${baseRoute}${route}`)
    const providerPathPrefixIfProviderPath = nonProviderRoutesWithBaseRoute.includes(route.path)
      ? ''
      : providerPrefixPath
    return {
      ...route,
      path: `${widgetPrefixPath}${providerPathPrefixIfProviderPath}${route.path}`,
    }
  })
}

function extractPathComponents(path) {
  const elementRegexes = [
    { label: 'queryString', regex: queryStringRegex },
    { label: 'widgetPrefix', regex: widgetPrefixRegex },
    { label: 'providerPrefix', regex: providerPrefixRegex },
    { label: 'baseRoute', regex: baseRoutePrefixRegex, replaceWith: '/' },
    { label: 'trailingSlash', regex: /\/$/ },
  ]

  const components = elementRegexes.reduce((acc, component) => {
    const { label, regex, replaceWith } = component
    const match = regex.exec(path)
    if (match) {
      const [fullMatch] = match
      path = path.replace(regex, replaceWith || '')
      acc[label] = fullMatch
    }
    acc[`has${capitalize(label)}`] = !!match
    return acc
  }, {})

  return {
    path,
    ...components,
  }
}

function makePathFromComponents({ path, widgetPrefix = '', providerPrefix = '' }, { includeBaseRoute = true, includeWidgetPrefix = true, includeProviderPrefix = true } = {}) {
  if (typeof path !== 'string')
    return
  if (!path.startsWith('/'))
    return path

  const widgetPrefixIfIncluded = includeWidgetPrefix ? widgetPrefix : ''
  const providerPrefixIfIncluded = (includeProviderPrefix && !nonProviderRoutes.includes(path)) ? providerPrefix : ''
  const baseRouteIfIncluded = includeBaseRoute ? baseRoute : ''
  return `${widgetPrefixIfIncluded}${providerPrefixIfIncluded}${baseRouteIfIncluded}${path}`
}

export {
  prefixRoutes,
  extractPathComponents,
  makePathFromComponents,
}
